/** Proposal Studio (visualizar/editar slide) — deals + rocket-search. */
export const PROPOSAL_STUDIO_ENABLED = true

/** Download/exportação PPTX — oculto até estabilizar. */
export const PROPOSAL_PPTX_EXPORT_ENABLED = false

/** Download Anexo 1 (PDF) — oculto até estabilizar. */
export const PROPOSAL_PDF_EXPORT_ENABLED = false

/** Salvar rascunho / Enviar / Ferramentas no editor — fluxo via rodapé do painel. */
export const PROPOSAL_FORM_ACTIONS_ENABLED = false

/** @deprecated Use PROPOSAL_STUDIO_ENABLED / PROPOSAL_PPTX_EXPORT_ENABLED */
export const PROPOSAL_PPTX_ENABLED = PROPOSAL_STUDIO_ENABLED && PROPOSAL_PPTX_EXPORT_ENABLED
